import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';
import CompressImage from '../Pages/CompressImages/CompressImage';
import Dashboard from '../Pages/Dashboard/Dashboard';
import Login from '../Pages/Login/Login';
import QStatusSrn from '../Pages/Quotations/QStatusSrn';
import RateAdmin from '../Pages/RateAdmin/RateAdmin';
import ListingDocument from '../Pages/UploadDocument/Listing';
import PanCheck from '../Pages/PanCheck/Pancheck';
import UploadDocument from '../Pages/UploadDocument/UploadDocument';
import { getUserData, headers } from '../Utils/utils';
import Ratecalculator from '../Pages/RateCalculator/Ratecalculator.js';
import axios from 'axios';
import { Constants } from '../Utils/Constants.js';

export default function RouterX() {
  const location = useLocation();
  const navigate = useNavigate();
  const cookies = new Cookies();
  const [user, setUser] = useState({});
  console.log("location?", location);
  
  const [userPermissions, setUserPermissions] = useState()
  const getUserPermission = async (employee_code,) => {
    // platform Id=2  (2 is for solution portal)
    let response = await axios.post(
      Constants.BACKEND_API_URL + 'services/permission',
      { employee_code: employee_code, platform_id: 2 },
      { headers: headers() }
    );
    setUserPermissions(response.data)
  }
  useEffect(() => {
    let accessToken = cookies.get('access_token');
    let notCheckToken = !accessToken || accessToken === 'undefined';
    // update the condition if more paths are required.
    if (location?.pathname?.includes('/quotation')) {
      //
    } else if (notCheckToken) {
      navigate('/login');
    } else {
      getUserData(setUser, navigate);
     

    }
  }, [location.pathname]);

  useEffect(()=>{

    getUserPermission(user?.employee_code)
  },[user?.employee_code])

  console.log("Usre is ");
  console.log(user)

  return (
    <Routes>
      <Route path="/">
        <Route path="" element={<Dashboard user={user} />} />
        <Route path="compressor" element={<CompressImage />} />
        <Route path="documents" element={<UploadDocument />} />
        <Route path="listing" element={<ListingDocument />} />
        <Route path="pancheck" element={<PanCheck user={user}/>} />
        <Route path="login" element={<Login setUser={setUser} />} />
        <Route path="rateadmin" element={<RateAdmin userRole={user?.rateadmin?.userRole} userCode={user?.employee_code} userPermission={userPermissions} />} />
        <Route path="ratecalculator" element={<Ratecalculator />} />
        <Route path="quotation/:quotid/:status/:bankid" element={<QStatusSrn />} />
      </Route>
    </Routes>
  );
}
